import React from "react";
import { videoElement } from "./video";

class LoadButton extends React.Component {
  render() {
    return (
      <button
        onClick={function() {
          videoElement.src =
            "https://interactive-examples.mdn.mozilla.net/media/examples/flower.mp4";
        }}
      >
        Load
      </button>
    );
  }
}

export { LoadButton };
